import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body { 
    font-family: Arial, sans-serif;
    overflow-x: hidden;
  }

  @supports (font-variation-settings: normal) {
    html { font-family: Arial, sans-serif; }
  }
`

export default GlobalStyles
